// extracted by mini-css-extract-plugin
export default {"coloredText":"HomePageStyles_coloredText__yDXDs","coloredText2":"HomePageStyles_coloredText2__v0vcn"};